import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertPanel = ({ alerts, onAlertClick, onDismiss }) => {
  const severityConfig = {
    critical: {
      icon: 'AlertCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/30'
    },
    high: {
      icon: 'AlertTriangle',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/30'
    },
    medium: {
      icon: 'Info',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent/30'
    },
    low: {
      icon: 'Bell',
      color: 'text-muted-foreground',
      bgColor: 'bg-muted/50',
      borderColor: 'border-border'
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="Bell" size={20} className="text-primary" />
          <h3 className="font-semibold text-foreground">Priority Alerts</h3>
          <span className="px-2 py-0.5 bg-error/10 text-error text-xs font-medium rounded-full">
            {alerts?.filter(a => a?.severity === 'critical')?.length}
          </span>
        </div>
        <Button variant="ghost" size="sm">
          View All
        </Button>
      </div>
      <div className="divide-y divide-border max-h-96 overflow-y-auto custom-scrollbar">
        {alerts?.length === 0 ? (
          <div className="p-8 text-center">
            <Icon name="CheckCircle" size={48} className="text-success mx-auto mb-2" />
            <p className="text-muted-foreground">No active alerts</p>
          </div>
        ) : (
          alerts?.map((alert) => {
            const config = severityConfig?.[alert?.severity];
            return (
              <div
                key={alert?.id}
                className={`p-4 hover:bg-muted/50 cursor-pointer transition-colors border-l-4 ${config?.borderColor}`}
                onClick={() => onAlertClick(alert)}
              >
                <div className="flex items-start gap-3">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${config?.bgColor}`}>
                    <Icon name={config?.icon} size={20} className={config?.color} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2 mb-1">
                      <h4 className="font-medium text-foreground text-sm">{alert?.title}</h4>
                      <button
                        onClick={(e) => {
                          e?.stopPropagation();
                          onDismiss(alert?.id);
                        }}
                        className="text-muted-foreground hover:text-foreground"
                      >
                        <Icon name="X" size={16} />
                      </button>
                    </div>
                    <p className="text-sm text-muted-foreground mb-2">{alert?.message}</p>
                    <div className="flex items-center gap-4 text-xs text-muted-foreground">
                      <span className="flex items-center gap-1">
                        <Icon name="Clock" size={12} />
                        {alert?.time}
                      </span>
                      {alert?.shipment && (
                        <span className="flex items-center gap-1">
                          <Icon name="Ship" size={12} />
                          {alert?.shipment}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default AlertPanel;